import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BookCar from "../components/BookCar";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
const RequestQuote = () => {
  return (
    <>
      <SEO
        title="Request a Quote | EZ Car Rentals Melbourne"
        description="Request a quote for car, van, or ute rental in Melbourne, Victoria, Australia. EZ Car Rentals offers competitive rates and flexible rental options. Get your personalized quote today!"
        keywords="request quote car rental, car rental quote Melbourne, van hire quote Victoria, ute rental quote Australia, vehicle rental quote, EZ Car Rentals quote"
        url="https://ezcarrentals.com.au/request-quote"
      />
      <StructuredData type="organization" />
      <Navbar />
      <div style={{ paddingTop: "80px" }}>
        <h1 className="visually-hidden">Request a Car Rental Quote</h1>
        <BookCar />
      </div>
      <Footer />
    </>
  );
};

export default RequestQuote;
